export const dayOfWeekMap = {
    MONDAY: 0,
    TUESDAY: 1,
    WEDNESDAY: 2,
    THURSDAY: 3,
    FRIDAY: 4,
    SATURDAY: 5,
    SUNDAY: 6,
};

export const sortTimeSlots = (timeSlots = []) => {
    return [...timeSlots].sort((a, b) => {
        const da = dayOfWeekMap[a.day_of_the_week];
        const db = dayOfWeekMap[b.day_of_the_week];

        return da - db;
    });
};

export const removeAllSpaces = (str?: string) =>
    !str
        ? ""
        : str
              .split(",")
              .map(s => s.trim())
              .join(",");

export const getDayAndMonth = (day: keyof typeof dayOfWeekMap) => {
    const idx = dayOfWeekMap[day];
    const today = new Date();
    const current = today.getDay();
    const sinceMonday = (current + 6) % 7;
    const monday = new Date(today);
    monday.setDate(today.getDate() - sinceMonday);
    const target = new Date(monday);
    target.setDate(monday.getDate() + idx);
    return { day: target.getDate(), month: target.getMonth() + 1 };
};

export const extractErrors = validationResult => {
    const errors = {};
    Object.keys(validationResult).forEach(key => {
        const val = validationResult[key];
        if (key !== "isValid" && val && val.isInvalid) {
            errors[key] = val.message;
        }
    });

    return errors;
};
